/**
 * Quantity badge component
 */
import clsx from 'clsx';
import type { ReactElement } from 'react';

export interface QuantityBadgeProps {
  quantity: number;
  className?: string;
}

export default function QuantityBadge({ quantity, className }: QuantityBadgeProps): ReactElement {
  return (
    <span
      className={clsx(
        'inline-flex h-5 min-w-5 items-center justify-center px-1.5',
        'bg-aether rounded-full text-xs font-semibold text-white',
        className,
      )}
    >
      {quantity}
    </span>
  );
}
